module.exports = __webpack_public_path__ + "img/Skilled Communicator.67449c9f.svg";